export enum TopUpTab {
  DATA = 'data',
  DASHBOARD = 'dashboard',
}
